import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";
import styles from "./VideoButton.module.scss";

const VideoButton = ({ openVideoModal, Model }) => {
  const handleClick = () => {
    openVideoModal();
    GAevent("Guest-User", "click", `Watch Product Video - ${Model}`);
  };

  return (
    <button className={`${styles.btn} videoBtn`} onClick={handleClick}>
      Watch Video
    </button>
  );
};

export { VideoButton };
